<template>
    <section class="employee-results-container">
        <table-results-helper :title="'Employee'">
            <template v-slot:table>
                <table class="table table-striped table-sm table-hover">
                    <thead>
                        <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Staff ID</th>
                            <th scope="col">Date of Birth</th>
                            <th scope="col">Leave Date</th>
                            <th scope="col"
                                class="table-right">
                                <div class='custom-control custom-checkbox'>
                                    <input 
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    id="employeesSelectAll" 
                                    :disabled="hasPerformedCaseSearch || !(employeeResults && employeeResults.length > 0)"
                                    :checked="isSelectAllChecked" 
                                    @click="selectAllEmployees">
                                    <label class="custom-control-label" for="employeesSelectAll">Select All</label>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template
                            v-if="employeeResults && employeeResults.length > 0">
                            <tr v-for="employee in employeeResults"
                                :key="employee.id">
                                <td>{{ employee.firstName }}</td>
                                <td>{{ employee.lastName }}</td>
                                <td>{{ employee.staffId }}</td>
                                <td>{{ employee.dateOfBirth | formatTableDate }}</td>
                                <td>{{
                                        employee.leaveDate ? 
                                        $options.filters.formatTableDate(employee.leaveDate)
                                        : 
                                        'NA'
                                    }}
                                </td>
                                <td class="table-right">
                                    <div class='custom-control custom-checkbox'>
                                    <input
                                        type="checkbox" 
                                        :id="'employeeSelect' + employee.id" 
                                        class="custom-control-input" 
                                        :disabled="hasPerformedCaseSearch"
                                        :checked="isSelected(employee.id)"
                                        @click="selectEmployee($event, employee)">
                                        <label class="custom-control-label" :for="'employeeSelect' + employee.id"></label>
                                </div>
                                </td>
                            </tr>
                        </template>
                        <template v-else-if="isFetchingUsers">
                            <tr>
                                <td colspan="6">
                                    <div class="d-flex justify-content-center">
                                        <div class="spinner-border text-secondary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-else-if="!isFetchingUsers && employeeResults != null && employeeResults.length === 0">
                            <tr>
                                <td
                                    id="noUsersMessage"
                                    class="centered"
                                    colspan="6">
                                    User not found, please check the details
                                    entered and try again
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <p
                    v-if="isMaxUserCountReached"
                    id="userLimitMessage"
                    class="centered message">
                    Result limit of {{ userResultLimit }} reached. Please be
                    more specific with your search criteria.
                </p>
            </template>
        </table-results-helper>
        <button
            v-if="employeeResults && employeeResults.length > 0"
            class="btn btn-primary view-cases-button btn-block"
            :disabled="!selectedEmployees.length > 0 || hasPerformedCaseSearch"
            @click="searchForCases">
            <template v-if="isFetchingCases">
                <span class="spinner-border spinner-border-sm button-spinner" role="status" aria-hidden="true"></span>
                Loading Cases
            </template>
            <template v-else>
            View Cases
            </template>
        </button>
    </section>
</template>

<script>
import TableResultsHelper from './helpers/TableResultsHelper.vue';

export default {
    components: {
        'table-results-helper': TableResultsHelper,
    },
    props: [
        'selectedEmployees',
        'employeeResults',
        'hasPerformedCaseSearch',
        'isFetchingUsers',
        'isFetchingCases',
    ],
    data() {
        return {
            userResultLimit: 20,
        };
    },
    computed: {
        isMaxUserCountReached() {
            return (
                this.employeeResults &&
                this.employeeResults.length === this.userResultLimit
            );
        },
        isSelectAllChecked() {
            return (
                this.employeeResults &&
                this.employeeResults.length === this.selectedEmployees.length
            );
        },
    },
    methods: {
        searchForCases() {
            this.$emit('searchForCases');
        },
        isSelected(employeeId) {
            return (
                this.selectedEmployees &&
                this.selectedEmployees.findIndex(
                    employee => employee.id === employeeId
                ) > -1
            );
        },
        selectEmployee($event, employee) {
            this.$emit('selectEmployee', $event, employee);
        },
        selectAllEmployees($event) {
            this.$emit('selectAllEmployees', $event);
        },
    },
};
</script>

<style lang="scss" scoped>
  .employee-results-container {
      display: flex;
      flex-direction: column;
      margin-bottom: var(--global-gutter-size);
      .view-cases-button {
          margin: 0 auto;
      }
      .centered {
          text-align: center;
      }
      .message {
          color: var(--global-secondary-font-color);
          font-size: 0.875rem;
      }
  }
  .button-spinner {
      margin-right: 12px;
  }
</style>
